export function GetMockCaseNoteList() {
  return [
    {
      id: 1680,
      dateAdded: "2022-08-04T16:07:43.1914442",
      noteText: "vm left ",
      caseId: 1443,
      addedByUserId: 77,
      isDeleted: 0,
      deletedDate: "0001-01-01T00:00:00",
    },
    {
      id: 1846,
      dateAdded: "2022-08-09T16:14:19.8619204",
      noteText: "vm",
      caseId: 1443,
      addedByUserId: 77,
      isDeleted: 0,
      deletedDate: "0001-01-01T00:00:00",
    },
    {
      id: 1959,
      dateAdded: "2022-08-12T17:00:47.1727279",
      noteText: "max calls made, email sent, no response, closed case ",
      caseId: 1443,
      addedByUserId: 77,
      isDeleted: 0,
      deletedDate: "0001-01-01T00:00:00",
    },
  ];
}
